import { createSelector } from 'reselect';
import resolveRequest, { getRequestStatus } from '@clearscore-group/lib.helpers.resolve-request';

const getProspectStatus = (state) => resolveRequest(state, 'prospect.status');

export default createSelector(getProspectStatus, (status) => ({
    fetch: getRequestStatus(status),
}));
